import type reportOnlineId from "./id";

const reportOnlineEn: typeof reportOnlineId = {
	report_online: {
		title: "Online Store Report",
		subtitle: "Sales and finance summary",
		tabs: {
			summary: "Summary",
			sales: "Sales",
			product: "Sales Per Product",
			customer: "Sales Per Customer",
		},
		filters: {
			store: "Store",
			all_stores: "All Stores",
			status: "Status",
			all_statuses: "All Statuses",
		},
		summary: {
			title: "Online Store Report",
			subtitle: "Online sales and finance summary",
			all_stores: "All Stores",
			loading_partner: "Loading partner info...",
			loading: "Loading...",
			empty: "No data",
			cards: {
				income: "Income",
				expense: "Expenses",
				summary: "Summary",
			},
			income: {
				cash: "Cash Payment",
				non_cash: "Non-Cash Payment",
				shipping: "Shipping Cost",
				total: "Total Income",
			},
			expense: {
				fee_mdr: "Fee (MDR)",
				commission: "Commission",
				total: "Total Expenses",
			},
			totals: {
				net_income: "Net Income",
				hpp: "Cost of Goods Sold (COGS)",
				shipping: "Shipping Cost",
				pnl: "Profit/Loss",
			},
		},
		sales: {
			title: "Sales Data",
			empty_state: {
				title: "No sales data",
				description: "No sales transactions in this period.",
			},
			summary_stats: {
				qty: "Sales Qty",
				total: "Total Sales",
				order_unit: "orders",
			},
			columns: {
				invoice_id: "Invoice ID",
				date: "Date",
				payment_method: "Payment Method",
				customer: "Customer",
				payment_amount: "Payment Amt.",
				discount: "Disc.",
				shipping_method: "Shipping Method",
				shipping_cost: "Shipping",
				resi: "Tracking/Courier",
				status: "Status",
			},
			status: {
				success: "Success",
				confirm: "Confirm",
				pending: "Pending",
				shipping: "Shipping",
				canceled: "Canceled",
			},
		},
		product: {
			title: "Sales Per Product Data",
			empty_state: {
				title: "No product sales data",
				description: "No product sales in this period.",
			},
			summary_stats: {
				total_qty: "Total Qty Sold",
				total: "Total Sales",
				item_unit: "items",
			},
			columns: {
				category: "Category",
				product: "Product",
				variant: "Variant",
				sold: "Sold",
				total: "Total",
			},
		},
		customer: {
			title: "Sales Per Customer Data",
			empty_state: {
				title: "No customer data",
				description: "No customer transactions in this period.",
			},
			columns: {
				name: "Name",
				phone: "Phone Number",
				email: "Email",
				qty: "Purchase Qty",
				total: "Total Purchases",
			},
		},
		modals: {
			sales: {
				title: "Sales Detail",
				sections: {
					sales_info: "Sales Information",
					customer_store: "Customer & Store Information",
					shipping: "Shipping Information",
				},
				fields: {
					invoice_id: "Invoice ID",
					date: "Date",
					total_payment: "Total Payment",
					payment_method: "Payment Method",
					discount: "Discount",
					status: "Status",
					customer: "Customer",
					store: "Store",
					shipping_method: "Shipping Method",
					shipping_cost: "Shipping Cost",
					resi: "Tracking/Courier",
				},
				close: "Close",
			},
			product: {
				title: "Product Detail",
				sections: {
					product_info: "Product Information",
					sales_info: "Sales Information",
				},
				fields: {
					product_name: "Product Name",
					category: "Category",
					variant: "Variant",
					sold_qty: "Sold Quantity",
					total: "Total Sales",
				},
				unit: "pcs",
				close: "Close",
			},
		},
	},
};

export default reportOnlineEn;
